module.exports = __webpack_public_path__ + "img/only-man.09770d40.svg";